import moment from 'moment';
import { useContext } from 'react';

import { ReactComponent as FilledAlertInfo } from '../../../../../assets/images/icon-filled-alert-info.svg';
import umbrellaIcon from '../../../../../assets/images/icon-filled-umbrella-beach.svg';
import { CheckIcon } from '../../../../legacy/components';
import { PauseEnrolmentContext } from '../../PauseEnrolmentContext';
import { enrolmentIsPaused, enrolmentWillBePaused } from '../PauseEnrolmentForm/helpers';

const PauseInfoBox = () => {
  const { selectedEnrolment } = useContext(PauseEnrolmentContext);
  const willBePaused = enrolmentWillBePaused(selectedEnrolment);
  const isPaused = enrolmentIsPaused(selectedEnrolment);
  const pauseStartDate = moment(selectedEnrolment.enrolmentPausedFrom);
  const resumptionDate = moment(selectedEnrolment.enrolmentPausedTo).add(1, 'day');

  if (isPaused || willBePaused) {
    return (
      <div className="mb-9 bg-blue-1 p-6">
        <div className="flex flex-row">
          <div className="mr-4">
            <FilledAlertInfo />
          </div>
          <div className="flex flex-col">
            <div className="font-bold">Summer pause requested</div>
            <div className="mt-3 space-y-4 leading-[24px]">
              <p>You have already requested to pause sessions for summer.</p>
              <p>
                Your enrolment will be paused from {pauseStartDate.format('dddd, D MMMM YYYY')} and resume on{' '}
                {resumptionDate.format('dddd, D MMMM YYYY')}.
              </p>
              <p>If you would like to change your pause, you can do so here.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const reasonsToPause = [
    <span>
      <span className="font-bold">Keep your paid sessions: </span> Any unused credits will automatically apply when you
      return.
    </span>,
    <span>
      <span className="font-bold">Stay connected: </span> You'll still have access to your past reports and recordings.
    </span>,
    <span>
      <span className="font-bold">Pick up anytime: </span> Resume your sessions whenever you're ready – no hassle.
    </span>,
  ];

  return (
    <div className="mb-9 rounded-lg bg-slate-1 p-9">
      <div className="w-full rounded-lg">
        <div className="flex flex-row items-start">
          <div className="mr-5 w-10 flex-shrink-0">
            <img src={umbrellaIcon} alt="umbrella" />
          </div>
          <p className="font-display text-2xl font-bold text-grey-6">
            Take a break – your tutoring sessions will be waiting!
          </p>
        </div>
        <div className="ml-[3.75rem] mt-6 text-lg">
          Need some time off? You can pause your plan without losing your progress.
        </div>
        <ul className="mt-6 flex flex-col gap-y-4 text-lg sm:ml-[3.75rem] md:mr-4">
          {reasonsToPause.map((reason, index) => {
            return (
              <li key={`pause_benefits_${index}`} className="mt-1 flex items-start text-grey-6">
                <CheckIcon className="mr-2.5 flex-shrink-0 text-green-4" width={24} height={24} />
                {reason}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PauseInfoBox;
